/**
 * Documents légaux publiés sur la vitrine (#360). Ils vivent sur studeva.fr, pas
 * dans l'app : un seul texte fait foi, celui de la page publiée.
 */
export type LegalPage = 'TERMS_OF_USE' | 'TERMS_OF_SALE' | 'PRIVACY'

const SITE_URL = 'https://studeva.fr'

const PATHS: Record<LegalPage, { fr: string, en: string }> = {
  TERMS_OF_USE: { fr: '/cgu', en: '/en/terms-of-use' },
  TERMS_OF_SALE: { fr: '/cgv', en: '/en/terms' },
  PRIVACY: { fr: '/confidentialite', en: '/en/privacy' },
}

/** URL d'un document dans la langue de l'interface ; le français pour toute autre langue que l'anglais. */
export function legalUrl(page: LegalPage, language: string): string {
  const paths = PATHS[page]
  return SITE_URL + (language.startsWith('en') ? paths.en : paths.fr)
}
